import PhoneFrame from '../../components/PhoneFrame';

const SS = (n) => `${process.env.PUBLIC_URL}/screenshots/phone_ss_${n}.jpg`;

const SCREENS = [
  { src: SS(1), label: 'Login'           },
  { src: SS(2), label: 'Games Feed'      },
  { src: SS(3), label: 'Match Details'   },
  { src: SS(4), label: 'Your Profile'    },
  { src: SS(5), label: 'Explore Players' },
  { src: SS(6), label: 'Squad Builder'   },
  { src: SS(7), label: 'Host Dashboard'  },
];

const DOUBLED = [...SCREENS, ...SCREENS];

export default function ScreensMarquee() {
  return (
    <section style={{ padding: '6rem 0', overflow: 'hidden', position: 'relative' }}>
      <div style={{ textAlign: 'center', padding: '0 clamp(1rem,4vw,3rem)', marginBottom: '3rem' }}>
        <span className="section-tag">THE APP</span>
        <h2 className="vis section-title" style={{ fontSize: 'clamp(36px,5vw,58px)' }}>
          Every Screen,<br /><span>Perfectly Crafted.</span>
        </h2>
      </div>

      <div
        style={{ display: 'flex', gap: '1.5rem', width: 'max-content', animation: 'ticker 40s linear infinite' }}
        onMouseEnter={e => (e.currentTarget.style.animationPlayState = 'paused')}
        onMouseLeave={e => (e.currentTarget.style.animationPlayState = 'running')}
      >
        {DOUBLED.map((s, i) => (
          <div key={i} style={{ flexShrink: 0 }}>
            <PhoneFrame
              src={s.src}
              alt={s.label}
              width={180}
              style={{
                transition: 'transform 0.3s, box-shadow 0.3s',
              }}
            />
            <div style={{
              textAlign: 'center', marginTop: 10,
              fontFamily: 'var(--font-m)', fontSize: 10,
              color: 'var(--muted)', letterSpacing: 1,
            }}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
